import { handleError } from './utils';

export const getMemberships = () => handleError(async (dispatch, getState, { api }) => {
  const [offers, freeTrial] = await api.getCustomersOffers();
  return [offers, freeTrial];
}, 'There was a problem getting the offers');

export const getPurchaseToken = (offerId, productIds) => handleError(async (dispatch, getState, { api }) => {
  const token = await api.getPurchaseToken(offerId, productIds);
  return token;
}, 'There was a problem getting the offers');
